import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Swipe from 'react-easy-swipe';
import Thumbnail from '../Lightbox/Thumbnail';
import StoryContent from './StoryContent';
import LoadingSpinner from '../utility/LoadingSpinner';
import { Carousel } from 'react-responsive-carousel';
import iconLeft from '../../images/icons/icon_48_leftchev.png';
import iconRight from '../../images/icons/icon_48_rightchev.png';
import blueGradientBG from '../../images/ReviewVertical_B.png';
import greyGradientBG from '../../images/ReviewVertical_G.png';
import { withTranslation } from 'react-i18next';

import {
  fetchStories,
  setActiveStory,
} from '../../actions/stories';

import {
  clearApiError,
} from '../../actions/api';

import {
  formatDate,
} from '../../js/utility';

class TileStories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      showPopup: false,
      popupStory: null
    };
    this.initData = this.initData.bind(this);
    this.setStoryInterval = this.setStoryInterval.bind(this);
    this.handleStoryClick = this.handleStoryClick.bind(this);
    this.changeStory = this.changeStory.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.togglePopUp = this.togglePopUp.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.clearApiError();
    const { hasFetched } = this.props;
    if(!hasFetched) {
      this.initData();
    }
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }


  setStoryInterval() {
    this.timer = setInterval(() => {
      const { stories, currentStory, setActiveStory } = this.props;
      let currIndex = stories.findIndex((story) => story.id === currentStory);

      if(currIndex + 1 >= stories.length) {
        setActiveStory(stories[0].id);
      } else {
        setActiveStory(stories[currIndex + 1].id);
      }
    }, this.props.interval);
  }

  handleStoryClick(id) {
    clearInterval(this.timer);
    this.props.setActiveStory(id);
  }

  togglePopUp(story, haveImage){
    if(story){
      story.haveImage = haveImage;
      this.setState({popupStory: story});
    }
    else{
      this.setState({popupStory: null});
    }
  }

  changeStory(amount) {
    const { stories, currentStory, setActiveStory } = this.props;
    const maxStories = stories.length;
    const currIndex = stories.findIndex((story) => story.id === currentStory);
    clearInterval(this.timer);
    if(currIndex >= maxStories - 1 && amount > 0) {
      setActiveStory(stories[0].id);
    } else if (currIndex === 0 && amount < 0) {
      setActiveStory(stories[maxStories - 1].id);
    } else {
      let newId = stories[currIndex + amount].id;
      setActiveStory(newId);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.timer);
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  async initData() {
    const { fetchStories, setActiveStory } = this.props;
    await fetchStories();
    const { stories } = this.props;
    if(this._isMounted && stories && stories.length > 0) {
      setActiveStory(stories[0].id);
      // this.setStoryInterval();
    }
  }

  render() {
    const { loading, error, stories, currentStory, t } = this.props;

    // sort review based on review date from newest to oldest (trip_date = review date = created_at)
    stories.sort(function(a,b){
      return new Date(b.trip_date) - new Date(a.trip_date);
    });

    const tileFrames = [];
    let topTile = 'short'; // short/long
    const greyCoordinate = [
      '1,1,0',
      '2,0,0',
      '3,0,1'
    ];
    const isMobile = this.state.width <= 768;
    let maxVerticalTile = (isMobile) ? 2 : 2;
    let maxHorizontalTile = (isMobile) ? 2 : 3;

    for (let i = 0; i < stories.length; i++){
      if (tileFrames.length && ((tileFrames[tileFrames.length - 1].tileColumns.length < maxHorizontalTile) || (tileFrames[tileFrames.length - 1].tileColumns[tileFrames[tileFrames.length - 1].tileColumns.length - 1].length < maxVerticalTile))){
        const frameIndex = tileFrames.length - 1;
        if (tileFrames[frameIndex].tileColumns.length && (tileFrames[frameIndex].tileColumns[tileFrames[frameIndex].tileColumns.length - 1].length < maxVerticalTile)){
          tileFrames[frameIndex].tileColumns[tileFrames[frameIndex].tileColumns.length - 1].push(stories[i]);
        }
        else{
          tileFrames[frameIndex].tileColumns.push([stories[i]]);
        }
        // if (i === 5) break;
      }
      else{
        tileFrames.push({tileColumns: [[stories[i]]]});
      }
    }

    const notSingle = tileFrames.length > 1;

    if(loading) {
      return (
        <LoadingSpinner />
      );
    }
    if(error || !stories || stories.length < 1) {
      return null;
    }
    return (
      <>
        <div
          className={`fe-overlay review-popup ${(this.state.popupStory) ? ' show' : ''}`}
          onClick={() => this.togglePopUp(null)}
        />
        <div
          className={`fe-review-popup-container ${(this.state.popupStory) ? ' show' : ''}`}
          tabIndex='0'
        >
          {(this.state.popupStory) ? (
            <>
              <div key={this.state.popupStory.id} className={`fe-stories-item mobile-only ${(this.state.popupStory.haveImage)? '': ' show'}`}>
                <div className="fe-stories-profile-desktop">
                  <div className="fe-stories-profile-img">
                    <img src={this.state.popupStory.avatar_img} alt=""/>
                  </div>
                </div>
                <StoryContent overlayText={t('home:readMore')}>
                  <div className="fe-stories-profile">
                    <div className="fe-stories-profile-img">
                      <img src={this.state.popupStory.avatar_img} alt=""/>
                    </div>
                    <div className="fe-stories-profile-info">
                      <div className="fe-stories-profile-name">{this.state.popupStory.name}</div>
                    </div>
                  </div>
                  <h3 className="fe-stories-trip-title">
                    <Link style={(this.state.popupStory.trip_status) ? null : {pointerEvents: 'none', cursor: 'none'}} to={`/trips/${this.state.popupStory.trip_slug}`}>{this.state.popupStory.trip_title}</Link>
                  </h3>
                  {(this.state.popupStory.gallery.length) ? (
                    <div className="fe-stories-picture">
                      <img src={this.state.popupStory.gallery[0].img_url} alt=''/>
                      {/* <img src={banner1} alt=''/> */}
                    </div>
                  ) : null}
                </StoryContent>
              </div>
              <div className={`fe-stories-review ${(this.state.popupStory.haveImage)? '': ' show'}`}>
                <p>{this.state.popupStory.story}</p>
              </div>
            </>
          ) : null}
        </div>

        <section className="fe-home-stories">
          <div className='container'>
            <h2 className="fe-tileStory-heading">What Other Explorers Are Saying</h2>
            <div className='fe-tileStory-main'>
              <Carousel
                className='fe-tileStory-carousel'
                showArrows={notSingle}
                showStatus={false}
                showIndicators={notSingle}
                showThumbs={false}
                stopOnHover={(isMobile) ? false : true}
                infiniteLoop={notSingle}
                autoPlay={notSingle}
                transitionTime={400}
                emulateTouch={notSingle}
                swipeScrollTolerance={5}
                swipeable={true}
                interval={5000}
              >
                {tileFrames.map((frame, y) => {
                  if (y !== 0 && !isMobile){
                    topTile = (!(y%2)) ? topTile : ((topTile === 'short') ? 'long': 'short');
                  }
                  return(
                    <div key={y} className='fe-tileStory-frame'>
                      {frame.tileColumns.map((column, i) => {
                        const columnWidth = 100/maxHorizontalTile + '%';
                        return (
                          <div key = {i} className = 'fe-tileStory-column' style = {{width: columnWidth}}>

                            {column.map((story, x) => {
                              // if (x && !(x%maxVerticalTile)){
                              //   if (topTile === 'short') topTile = 'long';
                              //   else topTile = 'short';
                              // }
                              if (i != 0 && x === 0){
                                if (topTile === 'short') topTile = 'long';
                                else topTile = 'short';
                              }
                              // let background;
                              // if (x === 0 && i === 0) background = 'linear-gradient(353deg, rgba(2,0,91,1) 48%, rgba(10,18,114,1) 75%, rgba(17,33,134,1) 89%, rgba(37,76,190,1) 100%)';
                              // else if (x === 0) background = 'url(' + banner2 +') no-repeat center/cover';
                              const haveImage = story.gallery.length > 0;
                              const background = 'url(' + ((story.gallery.length) ? (story.gallery[0].img_url) : (((greyCoordinate.indexOf((y+','+i+','+x)) > -1) ?  greyGradientBG : blueGradientBG))) + ') no-repeat center 0px/cover';
                              // const background = 'url(' + ((story.gallery.length) ? (banner1) : (gradientBG)) + ') no-repeat center/cover';
                              // const background = (i !== 0) ? 'url(' + eval('banner'+(i+1)) + ') no-repeat center/cover' : 'linear-gradient(353deg, rgba(2,0,91,1) 48%, rgba(10,18,114,1) 75%, rgba(17,33,134,1) 89%, rgba(37,76,190,1) 100%)';
                              return (
                                (isMobile) ? (

                                  (!haveImage ? (
                                    <div
                                      onClick = {() => this.togglePopUp(story, haveImage)}
                                      key = {x}
                                      className = {`fe-tileStory-tile ${(!(x%2)) ? topTile: ((topTile === 'short') ? 'long': 'short')} ${((greyCoordinate.indexOf((y+','+i+','+x)) > -1) ?  'greyBG' : '')}`}
                                      style = {{
                                        background: background
                                      }}
                                    >
                                      <h3 className={`fe-stories-trip-title ${(!haveImage)? 'show' : ''}`}>
                                        <Link style={(story.trip_status) ? null : {pointerEvents: 'none', cursor: 'none'}} to={`/trips/${story.trip_slug}`}>{story.trip_title}</Link>
                                      </h3>
                                      <div key={story.id} className={`fe-stories-item ${(haveImage)? '': ' show'}`}>
                                        <div className="fe-stories-profile-desktop">
                                          <div className="fe-stories-profile-img">
                                            <img src={story.avatar_img} alt=""/>
                                          </div>
                                        </div>
                                        <StoryContent overlayText={t('home:readMore')}>
                                          <div className="fe-stories-profile">
                                            <div className="fe-stories-profile-img">
                                              <img src={story.avatar_img} alt=""/>
                                            </div>
                                            <div className="fe-stories-profile-info">
                                              <div className="fe-stories-profile-name">{story.name}</div>
                                            </div>
                                          </div>
                                        </StoryContent>
                                      </div>
                                    </div>

                                  ):(
                                    <div
                                      onClick = {() => this.togglePopUp(story, haveImage)}
                                      key = {x}
                                      className = {`fe-tileStory-tile ${(!(x%2)) ? topTile: ((topTile === 'short') ? 'long': 'short')} ${((greyCoordinate.indexOf((y+','+i+','+x)) > -1) ?  'greyBG' : '')}`}
                                      style = {{
                                        background: background
                                      }}
                                    >
                                      <h3 className='fe-stories-trip-title'>
                                        <Link style={(story.trip_status) ? null : {pointerEvents: 'none', cursor: 'none'}} to={`/trips/${story.trip_slug}`}>{story.trip_title}</Link>
                                      </h3>
                                      <div key={story.id} className={`fe-stories-item ${(haveImage)? '': ' show'}`}>
                                        <div className="fe-stories-profile-desktop">
                                          <div className="fe-stories-profile-img">
                                            <img src={story.avatar_img} alt=""/>
                                          </div>
                                        </div>
                                        <StoryContent overlayText={t('home:readMore')}>
                                          <div className="fe-stories-profile">
                                            <div className="fe-stories-profile-img">
                                              <img src={story.avatar_img} alt=""/>
                                            </div>
                                            <div className="fe-stories-profile-info">
                                              <div className="fe-stories-profile-name">{story.name}</div>
                                            </div>
                                          </div>
                                        </StoryContent>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div
                                    key = {x}
                                    className = {`fe-tileStory-tile ${(!(x%2)) ? topTile: ((topTile === 'short') ? 'long': 'short')} ${((greyCoordinate.indexOf((y+','+i+','+x)) > -1) ?  'greyBG' : '')}`}
                                    style = {{
                                      background: background
                                    }}
                                  >
                                    <h3 className={`fe-stories-trip-title ${(!haveImage) ? 'show' : ''}`}>
                                      <Link style={(story.trip_status) ? null : {pointerEvents: 'none', cursor: 'none'}} to={`/trips/${story.trip_slug}`}>{story.trip_title}</Link>
                                    </h3>
                                    <div className={`fe-stories-review ${(haveImage)? '': ' show'}`}>
                                      <p>{story.story}</p>
                                    </div>
                                    <div key={story.id} className={`fe-stories-item ${(haveImage)? '': ' show'}`}>
                                      <div className="fe-stories-profile-desktop">
                                        <div className="fe-stories-profile-img">
                                          <img src={story.avatar_img} alt=""/>
                                        </div>
                                      </div>
                                      <StoryContent overlayText={t('home:readMore')}>
                                        <div className="fe-stories-profile">
                                          <div className="fe-stories-profile-img">
                                            <img src={story.avatar_img} alt=""/>
                                          </div>
                                          <div className="fe-stories-profile-info">
                                            <div className="fe-stories-profile-name">{story.name}</div>
                                          </div>
                                        </div>
                                      </StoryContent>
                                    </div>
                                  </div>
                                )
                              );
                            })}

                          </div>
                        );
                      })}
                    </div>
                  );
                })}

              </Carousel>
            </div>
          </div>
        </section>
      </>
    );
  }
}

TileStories.propTypes = {
  stories: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  fetchStories: PropTypes.func.isRequired,
  setActiveStory: PropTypes.func.isRequired,
  clearApiError: PropTypes.func.isRequired,
  currentStory: PropTypes.number.isRequired,
  interval: PropTypes.number.isRequired,
  hasFetched: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

TileStories.defaultProps = {
  interval: 2500,
};

const mapStateToProps = ({ storiesState }) => ({
  stories: storiesState.stories,
  currentStory: storiesState.currentStory,
  loading: storiesState.loading,
  hasFetched: storiesState.hasFetched,
  error: storiesState.error,
});

const mapDispatchToProps = {
  fetchStories,
  clearApiError,
  setActiveStory,
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TileStories));
